// src/lib/facture-suppression.js — ce que la fenêtre de suppression dit AVANT
// le clic.
//
// ⚠️ CHEMIN COMPTABLE (CGI 289). Module PUR : lecture seule, rien n'est écrit.
//
// ── Une seule règle (Dimitri, 2026-11-03) ────────────────────────────────
// Une facture ÉMISE (numérotée) ne s'efface JAMAIS, transmise ou non : on
// l'annule par un AVOIR, seule porte. Seul un BROUILLON (sans numéro) se
// supprime. La garde vraie est au serveur (peutSupprimerFacture,
// lib/invoice-handlers.js) ; l'écran ne montre la corbeille que sur un
// brouillon (HistoriquePanel). Si la fenêtre s'ouvre quand même sur une pièce
// émise (onglet périmé), elle le dit et ne propose aucune suppression.
//
// Avant : trois cas (brouillon, simple « le compteur revient à N », sévère
// avec case « transmise »). Les deux derniers supprimaient une pièce émise :
// retirés, avec la case et le drapeau confirmDelivered.

export const MESSAGE_FACTURE_EMISE =
  "Une facture émise ne se supprime pas : faites un avoir.";

/**
 * @param {object} args
 * @param {object} args.facture       - ligne mappée (num)
 * @param {boolean} args.estBrouillon - isDraftInvoice(facture)
 * @returns {{ cas, possible, titre, msg, okLabel }}
 */
export function decrireSuppressionFacture(args) {
  const a = args || {};
  if (a.estBrouillon) {
    return {
      cas: "brouillon",
      possible: true,
      titre: "Supprimer ce brouillon ?",
      msg: "Ce brouillon n'a JAMAIS consommé de numéro : le supprimer n'a aucune conséquence sur la numérotation, ne crée aucun trou et ne décale rien. Tu peux le régénérer autant de fois que nécessaire — le numéro ne sera attribué qu'à l'émission.",
      okLabel: "Supprimer le brouillon",
    };
  }
  const f = a.facture || {};
  return {
    cas: "emise",
    possible: false,
    titre: "Facture émise : pas de suppression",
    msg: `Facture N° ${f.num || "—"}. ${MESSAGE_FACTURE_EMISE}`,
    okLabel: "Supprimer",
  };
}
